import BillingPeriod from "../../../utils/services/project/accounting/billingPeriodService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(BillingPeriod);
let roles = rolesTemplate(BillingPeriod);

function prepareItem(i) {
  i.create_subsequent_text = i.create_subsequent
    ? i18n.t("billing-periods.yes")
    : i18n.t("billing-periods.no");
  return i;
}

const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  ...roles.actions
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
